import { useViewContext } from '../context'
import { DefaultContextSchema } from '../schemas'

export const useDefaultContext = () => {
  return useViewContext(DefaultContextSchema)
}
